<div class="flex flex-col min-h-screen">
  <!-- Header -->
  <app-header></app-header>

  <!-- Main content -->
  <main class="flex-1 w-full px-4">
    <div
      class="max-w-[1200px] min-h-[calc(100vh-160px)] bg-gray-50 mx-auto w-full flex flex-col items-center"
    >
      <div class="w-full">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>

  <!-- Footer -->
  <app-footer></app-footer>
</div>
